module.exports = __webpack_public_path__ + "static/media/yellow-warning.8fac7288.svg";